module.exports = __webpack_public_path__ + "static/img/youxiaTitle.9648569.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/youxiaTitle.png
// module id = W1Yy
// module chunks = 0